import axios from 'axios';
import {showDialog, showToast} from "vant";
import {useUserStore} from "@/stores/useUser.js";
import {emitter, hcf, log} from "@/components/utils/HComFunctions.js";
import {hdi} from "@/components/utils/HDeviceInfo.js";
import {hr} from "@/components/utils/HRouter.js";

let serverUrlsConfig = {
    ApiGw: '',
    AliasApiGw: '',
};

export function useHHttp() {

    let useUser = useUserStore();

    const setServerUrlsConfig = (config) => {
        serverUrlsConfig = config;
    };
    const getServerUrlsConfig = () => {
        return serverUrlsConfig;
    };

    // 初始化 HTTP 配置，设置 headers 和 Token
    const initHttp = () => {
        axios.defaults.headers['Access-Control-Max-Age'] = "43200";
        axios.defaults.headers['Content-Type'] = "text/plain";
        axios.defaults.headers['Accept'] = "application/json";
        axios.defaults.headers['Z-AUTH'] = useUser.token??"";
        axios.defaults.headers['Vue'] = "1";
    };

    // 设置 Token
    const setToken = () => {
        axios.defaults.headers['Z-AUTH'] = useUser.token;
    };

    // 请求函数
    const request = async (reqPath,
                           okCallBack,
                           {
                               errCallBack = null,
                               params = "",
                               reqType = 'POST',
                               isFullUrl = false,
                               isShowLoading = true,
                               loadingText = '正在获取数据',
                               loadingDelayMillTime = 300,
                               successCallbackAllResp = false,
                               forceToastErrorMsg = false,
                               isShowErrorToast = true,
                           }={}) => {

        // 判断是否已经初始化实例
        if (!axios) {
            showToast('Error: 网络未初始化');
            return;
        }

        if (!reqPath.trim()) {
            showToast('Error: 请求地址为空');
            return;
        }

        if (reqPath[0] !== '/' && !isFullUrl) {
            showToast('Error: 请求地址未以 "/" 开头');
            return;
        }

        let serverAddress = serverUrlsConfig.ApiGw;

        if (isFullUrl) {
            serverAddress = reqPath;
        } else {
            serverAddress += reqPath;
        }

        log(`==================\n发送 HTTP 请求:\n请求路径：${reqPath}\n请求完整地址：${serverAddress}\n请求内容：${params ? JSON.stringify(params) : '无'}\n请求类型：${reqType}\n==================`);

        let reqParams = {
            N: hdi.deviceNoChangeId, // 设备编号
            C: hdi.inviteCode, // 邀请码
            I: hdi.deviceId, // 设备 ID
            R: hcf.getRandomString(8), // 随机字符串
            F: hdi.platTypeNo, // 平台类型
            T: `${Math.floor(Date.now() / 1000)}`, // 时间戳
            V: hdi.appVersion, // 版本
            P: typeof params === 'object' ? JSON.stringify(params) : (params ?? ""),
            A: hdi.channelFlag, // 渠道标志
        };

        reqParams = await window.locat1on(JSON.stringify(reqParams), "true")

        if (isShowLoading) {
            emitter.emit("NETWORK_LOADING_VISIBLE", {
                "visible": true,
                "delayTime": loadingDelayMillTime,
                "loadingText": loadingText,
            });
        }

        try {
            let response = await axios.post(serverAddress, reqParams, {
                responseType: 'arraybuffer',
            });
            if (response.status === 200) {
                try {
                    emitter.emit("NETWORK_LOADING_VISIBLE", {
                        "visible": false,
                        "delayTime": loadingDelayMillTime,
                        "loadingText": loadingText,
                    });


                    let decodeStr = await window.locat1on(response.data, null)

                    if (decodeStr === "" || decodeStr.trim() === "") {
                        showToast("获取数据为空字符串");
                        response.data = {};
                    } else {
                        response.data = JSON.parse(decodeStr);
                    }
                    log(`==================\n收到 HTTP 数据：\npath: ${reqPath} \n数据: ${typeof response.data["d"] === 'object' ? JSON.stringify(response.data["d"]) : response.data["d"]}\n==================`);
                    if (typeof response.data === 'string') {
                        if (okCallBack != null) {
                            if (typeof okCallBack === 'function' && okCallBack.length === 0) {
                                okCallBack();
                            } else {
                                if (successCallbackAllResp) {
                                    okCallBack(response.data);
                                } else {
                                    okCallBack(response.data["d"]);
                                }
                            }
                        }
                    } else {
                        if (response.data["c"] === 0) {
                            if (okCallBack != null) {
                                if (typeof okCallBack === 'function' && okCallBack.length === 0) {
                                    okCallBack();
                                } else {
                                    if (successCallbackAllResp) {
                                        okCallBack(response.data);
                                    } else {
                                        okCallBack(response.data["d"]);
                                    }
                                }
                            }
                        } else {
                            log("错误提示："+response.data["m"]);
                            if (response.data["c"] === 10102003) {
                                useUser.removeUserInfo();
                            }
                            //token 失效
                            if (response.data["c"] === 403001) {
                                useUser.removeUserInfo();
                                showDialog({
                                    title: '提醒',
                                    message: response.data["m"],
                                    cancelButtonText:"暂不",
                                    showCancelButton:true,
                                    confirmButtonText: "去登录",
                                    confirmButtonColor: hcf.getMainColor()
                                }).then(()=>{
                                    setTimeout(()=>{
                                        hr.go("login");
                                    },500);
                                }).catch(()=>{});
                            } else {
                                if (errCallBack != null) {
                                    if (typeof errCallBack === 'function' && okCallBack.length === 0) {
                                        errCallBack();
                                    } else {
                                        errCallBack(response.data);
                                    }
                                    if (forceToastErrorMsg) {
                                        showToast(response.data["m"]??"");
                                    }
                                } else {
                                    if (isShowErrorToast) {
                                        showToast(response.data["m"]??"");
                                    }
                                }
                            }
                        }
                    }
                } catch (e) {
                    errorProcess(errCallBack, e);
                    log(e.stack);
                    if (isShowErrorToast) {
                        showToast("网络开小差了，请稍后重试.");
                    }
                }
            } else {
                //防止异常情况也要处理error callabck
                errorProcess(errCallBack, {
                    "stack":"请求返回非200",
                });
                if (isShowErrorToast) {
                    showToast("网络开小差了，请稍后重试..");
                }
            }
        } catch (err) {
            errorProcess(errCallBack, err);
            if (isShowErrorToast) {
                showToast('网络开小差了，请稍后重试...');
            }
        } finally {
            if (isShowLoading) {
                emitter.emit("NETWORK_LOADING_VISIBLE", {
                    "visible": false,
                });
            }
        }
    };


    function errorProcess(errCallBack, e) {
        //防止异常情况也要处理error callabck
        if (errCallBack != null) {
            if (typeof errCallBack === 'function' && errCallBack.length === 0) {
                errCallBack();
            } else {
                errCallBack(null);
            }
        }
        //
        log(e.stack);
    }
    return {
        setServerUrlsConfig,
        getServerUrlsConfig,
        initHttp,
        setToken,
        request,
    };
}
